import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  HostListener,
  ViewEncapsulation,
  Inject,
  DoCheck,
  Renderer2,
  Optional,
} from "@angular/core";
import { Question } from "../question/question.model";
import { Reply } from "../reply/reply.model";
import { QuestionService } from "../question/question.service";
import { ReplyService } from "../reply/reply.service";
import { ReplyComponent } from "../reply/reply.component";
import { AttachmentUploaderComponent } from "../shared/attachment-uploader/attachment-uploader.component";
import { ToastrService } from "ngx-toastr";

import { TranslationService } from "../translation/translation.service";
import { AppState } from "../app.service";
import { Path } from "../path/path-v2.model";
import { Router } from "@angular/router";
import { Apollo } from "apollo-angular";
import { CordovaService } from "../cordova.service";
import { I18n } from "../i18n.service";
import { SessionService } from "../session/session.service";
import { Observable } from "rxjs";
import { bounceInAnimation, fadeInLeftAnimation, fadeInRightAnimation, slideInLeftAnimation, slideInLeftOnEnterAnimation, slideInRightAnimation, slideOutLeftAnimation, slideOutRightAnimation } from "angular-animations";
import { AlertUserLikeListComponent } from "../alert-user-like-list/alert-user-like-list.component";
import { MobileChatBoardComponent } from "../pages/mobile-chat-board/mobile-chat-board.component";
import { MobileChatServiceService } from "../pages/mobile-chat-board/mobile-chat-service.service";
import { WINDOW } from "../window.service";
import { WalletService } from "../wallet/wallet.service";
import { RoutineV2Service } from "../routine-v2/routine-v2.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SpinnerService } from "../spinner.service";
import { AnalyticsServiceService } from "../services/analytics-service.service";
import { DomSanitizer } from "@angular/platform-browser";
import { RoutineService } from "../daily-content-v2/routine.service";
import { ModalController, Platform, PopoverController } from "@ionic/angular";
import { UserPublicProfileComponent } from "../components/user-public-profile/user-public-profile.component";
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
import { HomeUiService } from "../new-design/home-ui.service";
import { KyperDataApiService } from "../services/kyper-data-api.service";
import mixpanel from "mixpanel-browser";

@Component({
  selector: "app-full-screen-feed",
  templateUrl: "./full-screen-feed.component.html",
  styleUrls: ["./full-screen-feed.component.scss"],
  animations: [
    slideInLeftAnimation({ duration: 300 }),
    fadeInRightAnimation({ duration: 300 }),
    fadeInLeftAnimation({ duration: 300 }),
    slideInLeftOnEnterAnimation({duration:500, delay:100}),
    slideOutLeftAnimation({duration: 500, delay:0}),
    slideOutRightAnimation({duration:300, delay:0}),
    bounceInAnimation()
  ]
})
export class FullScreenFeedComponent implements OnInit, DoCheck, AfterViewInit {
  
  @Input() mode: string = "question";
  @Input() isPreview: boolean;
  @Input() inverted: boolean = false;
  @Input() small = false;
  @Input() replyId;
  @Output() closed: EventEmitter<any>;
  @Output() itemSelected: EventEmitter<any>;
  @ViewChild("uploader") uploader: AttachmentUploaderComponent;
  @ViewChild("replyBlock") replyBlock: ElementRef;
  @ViewChild("repliesContainer") repliesContainer: ElementRef;
  @ViewChild("textareaForFeeds") txtarea_post: ElementRef;
  @ViewChild('btn') btn: ElementRef;
  @ViewChild('h1')
  h1: ElementRef;
  @ViewChild('replyComponent') replyComponent: ReplyComponent;
  @Input() data;
  @Input() focuseTextArea;
  isTranslated;
  flag;
  isTextboxHide =true;
  textareaContentLength=0;
  leftState=false;
  rightState =false;
  path: Path;
  ishideComment: boolean = false;
  sortBy: string = "timestamp";
  private _optimisticIdCounter = -1;
  replyText: string = "";
  cachedReplyText: string = ""; // LUMBA-1383
  attachmentUrl: string = null;
  errors: { answerError: false };
  replyTo: Reply = null;
  replyToComponent: ReplyComponent;
  replyToId: number;
  isLoading: boolean = false;
  replyOffset: number;
  selected: boolean = false;
  voteLoading: boolean = false;
  user: any;
  question: any;
  isLoaded =false;
  tagName_id: number
  dataOfUser: Observable<any>;
  namesData: any[]
  tempData: any
  state: boolean = false;
  animation = ['bounceIn'];
  isScrolledBottom: boolean = false
  singleHabit: any
  commentCount: number = 0
  public replies: Reply[]
  public repliesTree: any[] =[]
  colleagueList = [];
  colleagues_len=0;
  isMobile: boolean;
  tagsArray = [{ id: 'test', username: 'test' }];
  page
  apiRepliesCount = 0;
  replyCount = 0;
  pathRegistration
  singlePost
  constructor(
    private i18n: I18n,
    private apollo: Apollo,
    private router: Router,
    private appState: AppState,
    private routine:RoutineService,
    private toastrService: ToastrService,
    private questionService: QuestionService,
    private replyService: ReplyService,
    private translationService: TranslationService,
    private cordovaService: CordovaService,
    private sessionService: SessionService,
    private mobileService: MobileChatServiceService,
    private routineV2Service: RoutineV2Service,
    private modalController :ModalController,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private toasterService: ToastrService,
    private walletService: WalletService,
    private analyticsService: AnalyticsServiceService,
    private sanitizer:DomSanitizer,
    private keyboard: Keyboard,
    private popoverController:PopoverController,
    public render: Renderer2,
    public platform: Platform,
    public homeUiService: HomeUiService,
    public kyperService: KyperDataApiService,
    @Inject(WINDOW) private window: Window,
  //  @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.path = this.appState.get("currentPath");
    this.user = this.appState.get("currentUser");
     this.pathRegistration = this.appState.get("pathRegistration");
    this.isMobile = this.appState.get('isMobile')
    // let dataOfFeeds = this.appState.get('singleFeed')
    // if (!dataOfFeeds) {
    //   this.refresh()
    // }
    // this.tempData = dataOfFeeds["question"];
    // this.mode = dataOfFeeds["modes"];
    // this.appState.set("mode", this.mode + "s");
    // this.question = this.sessionService.findById(this.path[dataOfFeeds["modes"] + 's'], this.tempData?.id)
    this.appState.set('oldActionPoints', this.walletService.actionPoints.value)
    this.analyticsService.setScreen(AnalyticsServiceService.FULLFEED)
    this.page = 1;
    this.singlePost = this.appState.get('singlePost')
    console.log("🚀 ~ FullScreenFeedComponent ~ constructor ~ this.singlePost:", this.singlePost)
  }

  async ngDoCheck() {
    // Only the view that OWNS the deleted comment may consume the GLOBAL commentDeleted flag. The
    // deleter (reply/comment component) stamps repliesTreeObject with the tree it was rendered from,
    // so a reference match identifies the owning view. Consuming it unconditionally STOLE the flag
    // from the community list components (comments-list-web / habit-comment-list-web) whose
    // ngDoCheck splice then never ran — the deleted comment stayed on screen in the individual AND
    // All tabs until the modal was reopened, even though the delete API succeeded.
    // `owner &&` (not a bare !==) so a delete made from THIS full-screen view — where no tree is
    // stamped — still refreshes as before; we only ever bow out when another view is the stamped owner.
    const owner = this.appState.get('repliesTreeObject');
    if (owner && owner !== this.repliesTree) { return; }
    let isCommentDeleted = this.appState.get('commentDeleted')
    let singlePost = this.appState.get('singlePost')
    if (isCommentDeleted) {
      this.appState.set('commentDeleted', undefined)
      this.page = 1;
      await this.getHabitDetails(singlePost);
    }
  }

  ngOnInit() {
    // LUMBA-1317
   setTimeout(()=>{
    if(this.focuseTextArea) {
      this.clickOnInput();
     }
   },600)
    
    this.isLoaded =false
    this.toggleSort("timestamp");
    this.singlePost = this.data;
    console.log("🚀 ~ FullScreenFeedComponent ~ ngOnInit ~ this.data:", this.data)
    this.getHabitDetails(this.singlePost)
    this.appState.set('communityNotification', undefined)
    this.appState.set('notificationData', undefined)
    mixpanel.track('opened via notification');
  }
  ngAfterViewInit() {
    this.resizeHeight();
    this.restoreResizeHeight();

    this.focusComment()
    window.scroll(0, 0);
    //     // this line moves the screen at the bottom scroll
    //this.replyOffset = 0;
    if(this.isMobile){
      if(this.platform.is('android')) {
       let id =document.getElementsByClassName('list-group')[0];       
      //  id?.setAttribute('style', 'margin-top:60px;')
        this.keyboard.onKeyboardDidShow().subscribe((info) => {
          console.log('keyboard will show with height', info.keyboardHeight);
          this.replyBlock.nativeElement.style.setProperty(
            'bottom',
            `${0}px`
          );
          this.replyBlock.nativeElement.style.setProperty(
            'padding-bottom',
            `${25}px`
          );
        });
    
        this.keyboard.onKeyboardDidHide().subscribe(() => {
          console.log('keyboard did hide');
          this.replyBlock.nativeElement.style.setProperty(
            'bottom',
            `${0}px`
          );
          this.replyBlock.nativeElement.style.setProperty(
            'padding-bottom',
            `${20}px`
          );
        });
      }
    }
    // this.showCommentsData(this.data);

  }

  resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
         const mobileLoginScreens = document.querySelector('.post_remaining_content.reply-container');
            mobileLoginScreens.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px); overflow-y: scroll`);
          console.log('keyboard show');
       });
  }

  restoreResizeHeight(){
    this.keyboard.onKeyboardWillHide().subscribe(() => {
      const mobileLoginScreens = document.querySelector('.post_remaining_content.reply-container');
        mobileLoginScreens.setAttribute('style', `height: auto`);
      console.log('keyboard hide');
    })
  }

  showCommentsData(data) {
    console.log("🚀 ~ FullScreenFeedComponent ~ showCommentsData ~ data:", data)
    this.commentCount = data.replies?.length
          
             var level1 = data.replies;
            this.colleagueList = data.colleaguesList;
            this.colleagues_len = data?.colleaguesCount;
            this.replyCount = data.replyCount;
            if (level1) {
              var subReply = level1.filter((item) => item.repliableId);
              level1.forEach((reply) => {
                if (!reply.replies) { reply.replies = []; }
                reply.timestamp = new Date(reply.createdAt);
                subReply?.forEach((element: any) => {
                  if (element?.repliableId === reply.id && !reply.replies.some((r: any) => r.id === element.id)) {
                    reply.replies.push(element);
                    reply.replies = [...new Set(reply.replies)];
                  }
                });
              });

              this.repliesTree = level1.filter(
                (reply) => reply.id && reply.replyLevel === 1
              );
              this.appState.set('repliesTreeObject', this.repliesTree);
              this.repliesTree.forEach((reply: any) => {
                if (!reply.subReplyCount) { reply.subReplyCount = reply.replies?.length ?? 0; }
              });
              console.log("🚀 ~ FullScreenFeedComponent ~ showCommentsData ~ this.repliesTree:", this.repliesTree)
              this.isLoaded =true;
        
              this.appState.set('repliesLength', this.repliesTree?.length)
            }
  
  }
  itemMentioned(tag) {
    console.log("selected ", tag);
  }
  async openUserInfo(ev, userData): Promise<void> {
    const popover = await this.popoverController.create({
      component: UserPublicProfileComponent,
      event: ev,
      mode:'ios',
      translucent: false,
      componentProps: {'user': userData}
    });
    await popover.present();
   
  }
  ngOnChanges(changes: SimpleChanges) {
    if (!changes.singlePost || changes.singlePost.firstChange) {
      return false;
    }
    // this.singlePost.sortRepliesBy(this.sortBy);
    this.cdRef.detectChanges();
  }

  toggleSort(by: string) {
    console.log("by:" + by);
    this.sortBy = by;
    // this.singlePost.sortRepliesBy(by);
  }

  hideAndShowComment() {
    if (this.ishideComment) {
      this.ishideComment = false;
    } else {
      this.ishideComment = true;
    }
  }
  checkTextareaLength() {
      let len = this.replyText?.trim();
      this.textareaContentLength =len.length;
      console.log("LENGTH>>>", len)
  }

  orderingSubReplies(reply) {
    this.isLoaded = true;
    let replySort;
    this.isTextboxHide = true;
    this.appState.set("isMobileReply", false);
    // this.commentCount = reply.replyCount;
    // this.data.votescount = reply?.voteCount;
    this.data.replyCount = this.data.replyCount+1;
    this.replyCount = this.data.replyCount;
    var level1 = [reply, ...this.repliesTree];
    if (level1) {
      var subReply = level1.filter(item => item.repliableId)
      level1?.forEach(reply => {
        subReply?.forEach(element => {
         if (element?.repliableId === reply.id) {
            const updatedReply = { ...reply };
            updatedReply.replies = [element, ...updatedReply.replies];
            updatedReply.timestamp = new Date(reply.createdAt);
            const index = level1.findIndex(r => r.id === updatedReply.id);
            level1[index] = updatedReply;
          }
        });
      });
      let repliesTree = level1.filter(reply => reply.id && reply.replyLevel === 1)
      this.repliesTree = repliesTree;
      // this.appState.set('repliesTreeObject', this.repliesTree);
      this.data.replies = this.repliesTree;
      console.log("repliestree in comment list", this.repliesTree);
    }
  }
  reply() {

    if(this.replyTo) {
      this.isTextboxHide =false;
     this.appState.set('isMobileReply',true)
    }
    if(this.textareaContentLength>0){
      this.isLoaded =false
    }
    console.log("New tag ", SessionService.getData()
    , this.replyText?.length);
    console.log("New tag ", typeof SessionService.getData()
    );
    let formatedText;
    //this.tagName_id = SessionService.getData()

    if (this.replyText?.length == 0) {
       this.isLoaded =true
      this.toastrService.error(
        this.i18n.t("Please enter a comment"),
        this.i18n.t("Error")
      );
      return false;
    }

    var list_of_tags_ids = []

    list_of_tags_ids = this.sessionService.getUserTAGs(this.replyText, this.complexItems)
    list_of_tags_ids = list_of_tags_ids.filter(userId => userId !== this.user?.id)

    this.isLoading = true;

    console.log("🚀 ~ FullScreenFeedComponent ~ reply ~ this.complexItems:", this.complexItems)
    this.complexItems?.forEach(element => {
           const username = element.username.toString().trim();
      const formattedUsername = username
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
      const exactMention = `@${formattedUsername}`;
      const regex = new RegExp(`(?<!\\w)${exactMention}(?!\\w)`, 'g');
      if (regex.test(this.replyText)) {
        const replaceValue = `<span id="${element.id}"><strong id="${element.id}">${formattedUsername}</strong></span>`;
        formatedText = this.replyText.replace(regex, replaceValue);
      }
    });

    //this.replyText=formatedText;

    this.unloadReply();
    if (formatedText) {
      this.cachedReplyText = formatedText;
    }
    if (this.replyTo) {
      this.isLoaded =true;

      console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ this.data:", this.singlePost)
      let replyType;
      if(this.replyTo.replyType=="action_reply"){
        replyType = "action_sub_reply"
      }else if(this.replyTo.replyType=="question_reply"){
        replyType = "question_sub_reply"
      }else{
        replyType = "habit_sub_reply"
      }
      let userIdsToNotify = list_of_tags_ids?.length > 0 
        ? list_of_tags_ids 
        : (this.replyTo?.user?.id === this.user?.id || this.replyTo?.user?.id === this.user?._data?.id) 
          ? [] 
          : [this.replyTo?.user?.id];
       let input = {
          screen_content_id: this.singlePost?.screenContentId,
          root_id: this.replyTo.id,
          reply_text: this.cachedReplyText,
          reply_type: replyType,
          reply_level: 2,
          user_ids: userIdsToNotify,
          comment_type:list_of_tags_ids?.length>0?'tag':'comment',
           is_translate: this.appState.get('selectedLanguage')? true:false
        }
        this.kyperService.postKyperUserReplies(input).subscribe((reply) => {
            this.ishideComment = true;
            const parentReplyId = this.replyTo.id;
            this.replyTo = null;
            this.replyToId = null;
            this.reset();
            this.isLoading = false;
            this.appState.set('isReplyAnimationApplied',true);
            this.toastrService.success(
              this.i18n.t("Comment posted!")
            );
            this.appState.set('isCommentPosted', true)
            this.replyComponent.replyText = '';
            this.replyComponent.isLoaded = true;
            this.replyComponent.isMobileLoaded=true
            //this.appState.set('oldPoints',this.walletService.actionPoints.value)
            //localStorage.setItem("oldPoints",this.walletService.actionPoints.value.toString())
            this.loadReply();
            // this.orderingSubReplies(reply)
            
            const normalizedSubReply = this.normalizeLevel2Reply(reply.data);
            this.repliesTree = this.insertLevel2Reply(parentReplyId, normalizedSubReply, this.repliesTree ?? []);
            // this.appState.set('repliesTreeObject', this.repliesTree);
             this.isLoading = true;
            this.data.replies = this.repliesTree;
            // this.getHabitDetails();
            this.cdRef.detectChanges();
            // if (this.repliesContainer != undefined) {
            //   this.repliesContainer.nativeElement.scrollIntoView();
            //   this.repliesContainer.nativeElement.scrollTop = 0;
            // }
          },
          (error) => {
            this.toastrService.error(
              this.i18n.t("Comment not posted. Check your connection and try reloading the app."),
              this.i18n.t("Error")
            );
            this.isLoading = false;
             this.isLoaded = true;
            this.isTextboxHide = true;
            this.appState.set("isAnimationApplied", true);
             this.appState.set("isMobileReply", false);
            this.loadReply();
            this.cdRef.detectChanges();
          }
        );
      this.loadReply();
      this.cdRef.detectChanges();
    } else {
      console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ this.singlePost:", this.singlePost)
      let input = {
          step_id: this.singlePost?.stepId,
          screen_id: this.singlePost?.screenId,
          screen_content_id: this.singlePost?.screenContentId,
          // APP-3074 — every customized version of an Action shares one screenContentId, so this is
          // what tells the backend WHICH card the comment was typed on. singlePost is that exact
          // card, and this is the last point where its identity still exists. Undefined on a base
          // Action card, which Rails stores as NULL and keeps on the base card.
          action_customization_id: this.singlePost?.actionCustomizationId,
          answer_text: this.cachedReplyText,
          is_translate: this.appState.get('selectedLanguage')? true:false,
          user_ids: list_of_tags_ids
        }
        this.kyperService.postKyperUserComment(input).subscribe((reply) => {
            this.ishideComment = true;
            this.reset();
            this.isLoading = false;
            this.replyTo = null;
            this.replyToId = null;
            this.appState.set('isAnimationApplied',true);
            this.loadReply();
            // this.getHabitDetails();
            // this.orderingSubReplies(reply.data);
            const normalizedReply = this.normalizeLevel1Reply(reply.data);
            this.repliesTree = [normalizedReply,...(this.repliesTree ?? [])];
            // this.appState.set('repliesTreeObject', this.repliesTree);
            this.isTextboxHide = true;
          this.appState.set("isMobileReply", false);
          this.data.replyCount = this.data.replyCount+1;
          this.replyCount = this.data.replyCount;
            this.data.replies = this.repliesTree;
            this.isLoading = true;
            this.toastrService.success(
              this.i18n.t("Comment posted!")
            );
            this.isLoaded = true;
            this.cdRef.detectChanges();
          },
          (error) => {
            console.log(error);
            this.loadReply();
            this.isLoaded = true;
            this.toastrService.error(
              this.i18n.t("Comment not posted. Check your connection and try reloading the app."),
              this.i18n.t("Error")
            );
            this.isLoading = false;
            this.cdRef.detectChanges();
          }
        );
      this.cdRef.detectChanges();
    }

    SessionService.setData(0)


  }

  normalizeLevel1Reply(raw: any): any {
    return {
      id: raw.questionId ?? raw.id ?? this._optimisticIdCounter--,
      replyText: raw.replyText ?? raw.answerText,
      replyLevel: 1,
      replyType: raw.replyType ?? 'action_reply',

      pathId: raw.pathId,
      stepId: raw.stepId ?? null,
      screenId: raw.screenId,
      screenContentId: raw.screenContentId,

      likes: [],
      replies: [],
      replyVotesCount: 0,
      hasVoted: false,
      subReplyCount: 0,

      userId: raw.userId,
      user: raw.user ?? this.user,              // current logged-in user

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  normalizeLevel2Reply(raw: any): any {
    return {
      id: raw.id,
      replyText: raw.replyText ?? raw.reply_text,
      replyLevel: 2,
      replyType: raw.replyType,

      pathId: raw.pathId,
      screenContentId: raw.screenContentId,
      rootId: raw.rootId ?? raw.root_id,

      likes: [],
      replies: [],

      replyVotesCount: 0,
      hasVoted: false,

      userId: raw.userId,
      user: raw.user ?? this.user,

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  insertLevel2Reply(parentReplyId: number, subReply: any, repliesTree: any[]): any[] {
    this.isLoaded =true;
    this.isTextboxHide = true;
    this.appState.set("isMobileReply", false);
    // this.data.replyCount = this.data.replyCount+1;
    const parentIndex = repliesTree.findIndex(r => r.id === parentReplyId);
    if (parentIndex === -1) return repliesTree;
    const parent = repliesTree[parentIndex];
    const updatedReplies = [subReply, ...(parent.replies || [])];
    const updatedParent = {
      ...parent,
      replies: updatedReplies,
      subReplyCount: updatedReplies.length
    };
    const remainingReplies = repliesTree.filter(r => r.id !== parentReplyId);
    return [updatedParent, ...remainingReplies];
  }

  translate($event){
    let toggleEnabled = $event.detail.checked
    console.log('toggleEnabled :', toggleEnabled);
    if (toggleEnabled === true) {
      this.isTranslated =true;
      this.flag =false;
      
      const repliesIds = this.repliesTree.map((reply) => reply.id);
       this.path = this.appState.get("currentPath");

      this.translationService
        .loadRepliesTranslations(repliesIds, this.path.language)
        .subscribe((translations) => {
          this.repliesTree.forEach((reply) => {
            const key = `Reply:${reply.id}`;
            reply.text = translations[key].text;
            this.isTranslated =false;
            this.flag = true
            this.cdRef.detectChanges()
          });
        });
      console.log('this.repliesTree after translation:', this.repliesTree);
    }

    else {
      this.flag = false;
      this.appState.set('commentDeleted', true)
      this.cdRef.detectChanges()
    }
  }

  reset() {
    this.replyText = "";
    this.attachmentUrl = null;
    if (this.uploader) {
      this.uploader.reset();
    }
    this.cachedReplyText = "";
  }

  // LUMBA-1383
  loadReply() {
    if (this.cachedReplyText) {
      this.replyText = this.cachedReplyText;
      this.cachedReplyText = "";
    }
  }

  // LUMBA-1383
  unloadReply() {
    this.cachedReplyText = this.replyText;
    this.replyText = "";
  }

  setReplyTo(replyComponent: ReplyComponent) {
    if (this.uploader) {
      this.uploader.reset();
    }
    // This code was needed when all replies was visible
    // Now all replies hidden except selected for reply
    if (this.replyToComponent) {
      this.replyToComponent.selected = false;
    }
    if(replyComponent?.selected){
      this.txtarea_post?.nativeElement.focus();
    }
    this.replyToComponent = replyComponent;
    if (replyComponent) {
      this.replyTo = replyComponent.reply;
      this.replyToId = this.replyTo.id;
    } else {
      this.replyTo = null;
      this.replyToId = null;
    }
  }

  refresh() {
    console.log(this.router.url);
    this.apollo.getClient().clearStore();
    this.appState.refreshMainComponent.emit();
  }
  onCommentClick() {
    this.txtarea_post?.nativeElement.focus();
      this.replyTo = null;
      this.replyToId = null;
  }
  scrollTo(event) {
    if (this.cordovaService.onCordova) {
      console.log("click event");
      console.log(this.replyBlock?.nativeElement.offsetTop);

      setTimeout(() => {
        window.scrollTo({
          top: this.replyBlock?.nativeElement.offsetTop - 160,
          behavior: "smooth",
        });
      }, 10);
    }
  }

  close() {
  
      this.modalController.dismiss();
   
  }

  totalLikes(items) {
    return items.reduce((a, b) => +a + +b.votesCount, 0);
  }

  clickOnInput() {
    this.txtarea_post?.nativeElement.focus();
  }



  toggleVote(reply) {
   
    this.bounceAnimation()

    this.voteLoading = true;
    reply.hasVoted = !reply.hasVoted;
    // reply.votescount += reply.hasVoted ? 1 : -1;
    if(!reply.replyVotesCount) {
      reply.replyVotesCount =0
    }
    reply.replyVotesCount += reply.hasVoted ? 1 : -1
    this.cdRef.detectChanges();
    if(reply.hasVoted)
    {
      reply.likes?.push(this.user?._data);
      this.data.likes = reply.likes;    
      this.singlePost.likes = reply.likes;  

    }
    else {
      reply.likes?.forEach( (user, index) => {
        if(user.id === this.user?._data.id) 
        reply.likes?.splice(index,1);
      });
      this.data.likes = reply.likes;    
      this.singlePost.likes = reply.likes;  
    }
    let likesData = {
        // user_id: this.user.id,
        path_id: this.path.id,
        post_id: reply.id,
        screen_content_id: reply.screenContentId
      }
      this.kyperService.postKyperUserLikes(likesData).subscribe({
        next: (res) => {
          reply.hasVoted = res.data.voteStatus;
          reply.replyVotesCount = res.data.totalLikes;
          this.cdRef.detectChanges();
        },
        complete: () => {
          this.voteLoading = false;
          this.cdRef.detectChanges();
        },
        error: () => {
          this.voteLoading = false;
        }
      });
  }

  complexItems = this.appState.get("userlist");
  

  tempValue = 0
  index = 0

  format(item: any) {
    var data = item['id'];
    setTimeout(() => {
      SessionService.setData(data)
      //this.tagsArray.push(item);
    }, 100);
    const username = item['username'].toString();
    const formattedUsername = username
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    return `@${formattedUsername}`;    //return item['username'].toUpperCase()
  }

  mentionConfig: any = {
    mentions: [
      {
        items: this.complexItems,
        labelKey: 'username',
        mentionSelect: this.format,
        dropUp: true
      }
    ]
  };


  focusComment() {
    if (this.appState.get('commentClicked')) {
      this.appState.set('commentClicked', false)
    
        this.txtarea_post?.nativeElement.focus();
    }
    else {
      this.txtarea_post?.nativeElement.blur();
    }
  }

  bounceAnimation() {
    this.render.addClass(this.btn.nativeElement, 'bounce');
    if(this.btn.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star')
    }
    else {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star-outline')

    }
    setTimeout(() => {
      this.render.removeClass(this.btn.nativeElement, 'bounce');
    }, 200);
  }

  showLikeList(postId: number, mode: string) {
    this.mobileService.setIsLikeList(true)
    this.mobileService.setPostId(postId)
    this.mobileService.setMode(mode)
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
  }

  showCommentList(mode: string, id: number) {

    const requestUserList = {
      id: id,
      path_id: this.path.id,
      mode: mode
    }
    this.mobileService.setIsLikeList(false)
    this.mobileService.setRequestUserList(requestUserList)
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
  }




  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        console.log('cordova not click')
        window.open(e.target.href, '_blank')
      }
    }
    if(e.target.tagName.toLowerCase() === 'span' || e.target.tagName.toLowerCase()=='strong'){
      if (e?.target?.id || e.target?.parentElement.id) {
        this.getUserData(e, e.target.id? e.target.id: e.target?.parentElement.id);
      }
    }
  }

  getUserData(event, id){
    this.routine.getUserDetailsById(id).subscribe(value=>{
      console.log('userid....', value);
      this.openuserInfo(event, value.data?.[0]);
    });
  }
  async openuserInfo(ev, userData): Promise<void> {
    const popover = await this.popoverController.create({
      component: UserPublicProfileComponent,
      event: ev,
      mode:'ios',
      translucent: false,
      componentProps: {'user': userData}
    });
    await popover.present();
   
  }

  onClick(): void {
    this.h1?.nativeElement.scrollIntoView({
      top: this.h1?.nativeElement.offsetTop,
      behavior: 'smooth'
    });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const offset = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 100) {
      this.isScrolledBottom = true
    } else {
      this.isScrolledBottom = false
    }
  }
 doInfinite(event) {
    console.log('doInfinite :');
    this.getHabitDetails(event);
  }
  getHabitDetails(post): Promise<any> {
    return new Promise( async (resolve, reject) => {
      try {
        let data
        console.log('post', post)
        // APP-3074 — "See More" fetches the hidden comments again, and every customized version of
        // an Action carries the same screenContentId. Without the card identity all three cards ask
        // an identical question and Rails answers with the combined thread. Actions only: Questions
        // and Habits keep asking exactly as they did.
        const isAction = post?.type === 'Action';
        data = {
            screenContentId: post.screenContentId,
              cardScoped: isAction,
              actionCustomizationId: isAction ? post?.actionCustomizationId : null,
              path_id: this.path.id,
              page: this.page
          }
        console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ data:", data)
      await this.routineV2Service.getKyperPostRepliyDetailsById(data).subscribe(
        (response) => {
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ response:", response)
          let postResponse = response.replies[0]
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ response 2:", postResponse)
          let replies = response.replies[0].userAnswers
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ replies:", replies)
          this.isLoaded =true
          this.isTextboxHide =true;
          this.appState.set('isMobileReply',false)
          this.commentCount = postResponse.replyCount;
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ this.commentCount:", this.commentCount)
          this.data.replyVotesCount= postResponse.replyVotesCount;
          this.data.replyCount = postResponse.replyCount;  
           var level1;
             if(this.page ==1) {
                this.apiRepliesCount = 0;
               this.repliesTree = [];
             }
            if (this.page == 1 && replies?.length > 0) {
              this.repliesTree = [];
              level1 = replies;
            }
            else if (replies?.length > 0) {
              level1 = this.repliesTree.concat(replies);
            }
          this.replyCount = postResponse.replyCount;
          this.apiRepliesCount += replies?.length;
          this.colleagueList = postResponse.colleaguesList;
          this.colleagues_len = postResponse.colleaguesCount;
          this.repliesTree = (level1 ?? replies).filter((reply: any) => reply.id && reply.replyLevel === 1)
          this.appState.set('repliesTreeObject', this.repliesTree);
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ this.repliesTree:", this.repliesTree)
          this.page = this.page + 1
          this.data.replies = this.repliesTree;
          console.log('repliesTree', this.repliesTree)            
          this.appState.set('repliesLength', this.repliesTree.length)
          console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ this.isLoaded:", this.isLoaded)
            this.cdRef.detectChanges()
        },

        (error) => {
          this.isLoaded =true
          this.isTextboxHide =true;
          this.appState.set('isMobileReply',false)
          console.log('error', error)
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
        }
      )
      resolve(true);
    } catch (error) {
      this.isLoaded =true
      this.isTextboxHide =true;
      this.appState.set('isMobileReply',false)
      console.log('error', error)
      reject(error);
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
    }
    });
  }

  translatePost(language: string,text: any){

    let data = {
      language: language,
      text: text
    }

    this.mobileService.translateContent(data).subscribe(
      (response) => {
        console.log('response :', response);
        if(response.status){
          this.replyText = response.data.text
          this.cdRef.detectChanges()
          this.toastrService.success(this.i18n.t('Post translated successfully!'))
        }
      },
    (error) => {
      this.toastrService.error(this.i18n.t('Text translation failed!'))
      console.log("TranslationService data ",error);
    }
    )
  }

}
